import { render, staticRenderFns } from "./Employment.vue?vue&type=template&id=2a2e4b4f&scoped=true"
import script from "./Employment.vue?vue&type=script&lang=js"
export * from "./Employment.vue?vue&type=script&lang=js"
import style0 from "./Employment.vue?vue&type=style&index=0&id=2a2e4b4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2e4b4f",
  null
  
)

export default component.exports